import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () => ({
  closeButton: {
    color: colors.textDark
  },
  listChoice: {
    background: colors.white,
    color: colors.blue700
  },
  settingsButton: {
    "&:hover": {
      background: colors.gray100
    },
    "&:active": {
      backGround: colors.gray200
    }
  }
});
